import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnInit,
	ViewChild
} from '@angular/core';
import { MfeLoaderService } from "@shared/services/mfe-loader.service";
import { RenderOptions } from "@shared/models/render.options";

@Component({
	selector: 'rx-mfe-container',
	template: '<div #container></div>',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MfeContainerComponent implements OnInit {
	@Input()
	appId: string = '';

	@ViewChild('container', { static: true })
	container!: ElementRef;
	constructor(
		private readonly mfeLoaderService: MfeLoaderService,
		private readonly cdr: ChangeDetectorRef
	) {
	}

	ngOnInit(): void {
		this.bootstrapMfe().then();
	}

	private async bootstrapMfe(): Promise<void> {
		const renderOptions: RenderOptions = {
			appId: this.appId,
			rootElement: this.container.nativeElement,
			appParameters: {
				basePath: 'rx',
			},
		};

		await this.mfeLoaderService.renderRemote(renderOptions);
		this.cdr.markForCheck();
	}
}
